import Vue from 'vue'
import Vuex from 'vuex'
import {TOKEN} from "@/config/http-json";
import router from "@/router";
import {Toast} from "vant";
import auth from "@/api/auth";
import {user, cartridge} from "@/store/modules";
import userApi from "@/api/user";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectAddress:
      JSON.parse(window.localStorage.getItem("selectAddress")) || null,
    submitNumber: 1,
    productInfo: null,
    modelCode: null,
    userInfo: (() => {
      const userinfoStr = localStorage.getItem('userinfo')
      if (userinfoStr) {
        return JSON.parse(userinfoStr)
      }
      return null
    })(),
    whereToBuy: null
  },
  mutations: {
    setSelectAddress(state, payload) {
      state.selectAddress = payload;
      window.localStorage.setItem("selectAddress", JSON.stringify(payload));
    },
    setSubmitNumber(state, payload) {
      state.submitNumber = payload;
    },
    setProductInfo(state, payload) {
      state.productInfo = payload;
    },
    setModelCode(state, payload) {
      state.modelCode = payload;
    },

    setNH608UserInfo(state, payload) {
      localStorage.setItem("userinfo", JSON.stringify(payload))
      state.userInfo = payload
    },
    setWhereToBuy(state, payload) {
      state.whereToBuy = payload
    }
  },
  actions: {
    //#region 授权令牌无效，请重新登录
    async tokenExpired({commit}) {
      //清空store
      //清空缓存
      localStorage.clear();
    },
//924248 17788765949
    async login({commit}, params) {
      try {
        const data = await auth.login(params);
        localStorage.setItem(TOKEN, data.token);
        commit('setNH608UserInfo', data)
        router.back()
      } catch (e) {
        Toast.fail({
          duration: 2000,
          message: e.message,
          closeOnClick: false,
          closeOnClickOverlay: false
        });
      }
    },
    //#endregion
    async loadStoreList({commit}, tagId) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          // 获取经纬度
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          console.log("Latitude: " + latitude);
          console.log("Longitude: " + longitude);

          const data = await userApi.fetchStores({
            lat: latitude,
            lng: longitude,
            tag: tagId
          })
          commit("setWhereToBuy", data.data)
          return data.data
          // 你可以在这里做其他的操作，例如将经纬度发送给服务器
        }, async (error) => {

          const data = await userApi.fetchStores({
            tag: tagId
          })
          commit("setWhereToBuy", data.data)
          console.error("Error Code: " + error.code + ", " + error.message);
        });
      } else {

        const data = await userApi.fetchStores({
          tag: tagId
        })
        commit("setWhereToBuy", data.data)

        console.log("Geolocation is not supported by this browser.");
      }
    }
  },
  getters: {
    getProductInfo(state) {
      return state.productInfo
    },
    getModelCode(state) {
      return state.modelCode
    },

    getUserName(state, commit) {
      if (state.userInfo == null) {
        return ''
      }
      return state.userInfo.nickName;
    }
  },
  modules: {
    user,
    cartridge
  }
});
